export default "__VITE_ASSET__DhL6dbMb__"